<template lang="pug">
  v-container
    h1.secondary--text {{ title }}
    v-divider
    p.text-justify {{ text }}
    ul
      li(v-for='l in list', :key='l.id') {{ l.text }}
    br
    p.text-justify {{ subtext }}
</template>

<script>
export default {
  name: 'information',
  props: {
    icon: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    subtext: {
      type: String,
      required: false,
      default: ''
    },
    list: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    }
  }
}
</script>
